// Module
var code = "<div class=\"card bg-white\"> <modal-header [title]=\"'Αλλαγή προφίλ'\" [isFirstStep]=\"true\" (emitCloseModal)=\"closeModal()\"> </modal-header> <div class=\"modal-wrapper-padding\"> <spinner [show]=\"loading\"> <div class=\"margin-top-normal\"></div> <div class=\"footer-buttons-container\"></div> </spinner> </div> </div> ";
// Exports
module.exports = code;